module.exports = __webpack_public_path__ + "assets/images/template/project/photo-2.jpg?v=2a6eaaf7";